module.exports = __webpack_public_path__ + "img/pending.6521ca4a.svg";